//TO-DO: Es necesario revisar otra forma de setear los id's, para no utilizar un ID que podria no ser en la DB
export const ID_REAGENDA = 1;
export const ID_CANCELACION = 2;
export const ID_ASIGNACION = 3;
export const ID_OCIOSIDAD = 4;
export const TIPO_MOTIVOS = {}

TIPO_MOTIVOS[ID_REAGENDA] = {
	id: ID_REAGENDA,
	label: 'Reagenda_de_turno'
}

TIPO_MOTIVOS[ID_CANCELACION] = {
	id: ID_CANCELACION,
	label: 'Cancelación_de_turno'
}

TIPO_MOTIVOS[ID_ASIGNACION] = {
	id: ID_ASIGNACION,
	label: 'Asignacion_de_turnos'
}

TIPO_MOTIVOS[ID_OCIOSIDAD] = {
	id: ID_OCIOSIDAD,
	label: 'Ociosidad'
}
